// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".comment-body[data-v-477b7e40]{width:100%}.comment-text[data-v-477b7e40]{white-space:pre-wrap}\n", "",{"version":3,"sources":["CommentItemBasic.vue"],"names":[],"mappings":"AA4CA,+BACE,UAAW,CACZ,+BAGC,oBAAqB","file":"CommentItemBasic.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.comment-body {\n  width: 100%;\n}\n\n.comment-text {\n  white-space: pre-wrap;\n}\n"]}]);
// Exports
module.exports = exports;
